import {ErrorMessage, Form, Formik} from 'formik'
import {FC} from 'react'

import {FormButton} from '@/components/common/form/FormButton'
import {FormErrorMessage} from '@/components/common/form/FormErrorMessage'
import {FormItem} from '@/components/common/form/FormItem'
import {GDPRConsent} from '@/components/inputs/GDPRConsent'
import {TextArea} from '@/components/inputs/TextArea'
import {TextInput} from '@/components/inputs/TextInput'
import {UserLocaleHiddenFields} from '@/components/user/UserLocaleHiddenFields'
import {useCommonContent} from '@/content/common'
import {useServiceCommonContent} from '@/content/service-request/common'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {Service} from '@/utils/service-request/types'
import {analytics} from '@/utils/tracking/analytics'
import {serviceRequestContactSchema} from '@/utils/validations/common/serviceRequest'

import {useServiceRequestSubmit} from '../form/useServiceRequestSubmit'
import {ServiceRequestFormLayout} from '../ServiceRequestFormLayout'

export const ResponseToOppositionForm: FC = () => {
  const {t} = useTranslation()
  const {saveTrademarkTitle, description, messagePlaceholder, buttonText} =
    useServiceCommonContent().form
  const {
    firstNameLabel,
    firstNamePlaceholder,
    lastNameLabel,
    lastNamePlaceholder,
    emailLabel,
    emailPlaceholder,
    messageLabel,
  } = useCommonContent()

  const trackSubmit = () => analytics.track('Submit', {form: 'Opposition response'})

  const {handleSubmit, submitError} = useServiceRequestSubmit({
    serviceType: Service.responseToObjection,
    onTrack: trackSubmit,
    errorPath: '/opposition-response',
  })

  return (
    <>
      <ServiceRequestFormLayout title={t(saveTrademarkTitle)} description={t(description)}>
        <Formik
          initialValues={serviceRequestContactSchema.getDefault()}
          validationSchema={serviceRequestContactSchema}
          onSubmit={handleSubmit}
        >
          {({status}) => (
            <Form encType="multipart/form-data">
              <UserLocaleHiddenFields />
              <FormItem label={t(firstNameLabel)} required>
                <ErrorMessage
                  name="firstName"
                  render={(msg) => <FormErrorMessage message={msg} />}
                />
                <TextInput name="firstName" placeholder={t(firstNamePlaceholder)} />
              </FormItem>
              <FormItem label={t(lastNameLabel)} required>
                <ErrorMessage
                  name="lastName"
                  render={(msg) => <FormErrorMessage message={msg} />}
                />
                <TextInput name="lastName" placeholder={t(lastNamePlaceholder)} />
              </FormItem>
              <FormItem label={t(emailLabel)} required>
                <ErrorMessage name="email" render={(msg) => <FormErrorMessage message={msg} />} />
                <TextInput type="email" name="email" placeholder={t(emailPlaceholder)} />
              </FormItem>
              <FormItem label={t(messageLabel)}>
                <ErrorMessage name="message" render={(msg) => <FormErrorMessage message={msg} />} />
                <TextArea name="message" placeholder={t(messagePlaceholder)} />
              </FormItem>
              <div className="wrapper">
                <GDPRConsent />
              </div>
              <FormButton
                text={t(buttonText)}
                dataTest="serviceSubmit"
                status={status}
                submitError={submitError}
              />
            </Form>
          )}
        </Formik>
      </ServiceRequestFormLayout>

      <style jsx>{`
        .wrapper {
          margin-top: ${theme.spacing[4]};
        }
      `}</style>
    </>
  )
}
